/**
 * Notification Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Target } from './target';
import { Actor } from './actor';
import { Event } from './event';
import { Client } from './client';
import { Security } from './security';


export interface EventDto { 
    mnemonic?: string | null;
    actor?: Actor | null;
    client?: Client | null;
    event?: Event | null;
    security?: Security | null;
    target?: Array<Target> | null;
}

